import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueMask from 'v-mask'
import VueSignaturePad from 'vue-signature-pad'
import flatpickr from 'flatpickr'
import VueHtml2Canvas from 'vue-html2canvas'

// import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

Vue.use(VueHtml2Canvas)

// Signature
Vue.use(VueSignaturePad)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// v-mask
Vue.use(VueMask)

Vue.use(flatpickr)
const Dutch = require('flatpickr/dist/l10n/nl.js').default.nl
// import { Dutch } from "flatpickr/dist/l10nnl.js"
flatpickr.localize(Dutch) // default locale is now Russian

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
